import TranslatableHelmet from './TranslatableHelmet';

export default TranslatableHelmet;
